import { render, staticRenderFns } from "./AuthorForm.vue?vue&type=template&id=bacba88c&scoped=true&"
import script from "./AuthorForm.vue?vue&type=script&lang=js&"
export * from "./AuthorForm.vue?vue&type=script&lang=js&"
import style0 from "./AuthorForm.vue?vue&type=style&index=0&id=bacba88c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacba88c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardSubtitle,VCardTitle})
